module.exports = __webpack_public_path__ + "img/b4.cbffc33d.jpg";